
import { useState } from 'react'
import { PhoneInputStep } from './PhoneInputStep'
import { RegistrationDetailsStep } from './RegistrationDetailsStep'
import { PhoneVerificationForm } from './PhoneVerificationForm'
import { useAuth } from '@/contexts/AuthContext'
import type { RegistrationDetailsData } from '@/types/auth'

type SignUpStep = 'phone' | 'details' | 'verification'

interface SignUpFlowProps {
  onSuccess?: () => void
  onLoginClick?: () => void
}

export function SignUpFlow({ onSuccess, onLoginClick }: SignUpFlowProps) {
  const [currentStep, setCurrentStep] = useState<SignUpStep>('phone')
  const [validatedPhone, setValidatedPhone] = useState<string>('')
  // Prova de verificação do telefone emitida pelo verify; exigida no sign-up.
  const [verificationToken, setVerificationToken] = useState<string>('')
  const { validatePhone, signUpWithDetails, verifyPhone, resendCode, isLoading, error, clearError } = useAuth()

  const handlePhoneSubmit = async (phone: string) => {
    try {
      await validatePhone({ phone })
      setValidatedPhone(phone)
      setCurrentStep('verification')
    } catch (error) {
      // Error is handled by useAuth hook
    }
  }

  const handleBackToPhone = () => {
    setCurrentStep('phone')
    clearError()
  }

  const handleDetailsSubmit = async (data: RegistrationDetailsData) => {
    try {
      await signUpWithDetails(validatedPhone, verificationToken, data)
      onSuccess?.()
    } catch (error) {
      // Error is handled by useAuth hook
    }
  }


  const handleVerificationComplete = async (code: string) => {
    try {
      const token = await verifyPhone({ phone: validatedPhone, code })
      setVerificationToken(token)
      setCurrentStep('details')
    } catch (error) {
      // Error is handled by useAuth hook
    }
  }

  const handleResendCode = async () => {
    try {
      await resendCode({ phone: validatedPhone })
    } catch (error) {
      // Error is handled by useAuth hook
    }
  }

  if (currentStep === 'verification') {
    return (
      <PhoneVerificationForm
        phone={validatedPhone}
        onVerificationComplete={handleVerificationComplete}
        onResendCode={handleResendCode}
        onBack={handleBackToPhone}
        isLoading={isLoading}
        isResending={isLoading}
        error={error}
      />
    )
  }

  if (currentStep === 'details') {
    return (
      <RegistrationDetailsStep
        phone={validatedPhone}
        onDetailsSubmit={handleDetailsSubmit}
        onBack={handleBackToPhone}
        isLoading={isLoading}
        error={error}
      />
    )
  }

  return (
    <PhoneInputStep
      onPhoneSubmit={handlePhoneSubmit}
      onLoginClick={onLoginClick}
      isLoading={isLoading}
      error={error}
    />
  )
}